let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6L8i3")).then(() => parcelRequire('JoC6s'));